<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Bitácora</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">
                            <DataTable :url="url" :columns="columns" :params="displayInputs" :order="[]"
                                :formatterActions="formatterActions" @apiDT="apiDT = $event"></DataTable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            showcargando: false,
            conclusion: false,
            url: "Utilidades/Bitacora",
            displayInputs: {
            },
            apiDT: null,
            columns: [
                { name: 'Reporte', data: 'nrreporte', title: "Reporte", formatter: [this, "reporteForm"], },
                { name: 'Siniestro', data: 'svnumsin', title: "Siniestro" },
                { name: 'Poliza', data: 'dapoliza', title: "Póliza" },
                { name: 'Asistencia', data: 'ainombre', title: "Asistencia" },
                { name: 'Aseguradora', data: 'clnombrecorto', title: "Aseguradora" },
                { name: 'Fecha Siniestro', data: 'svfhsiniestro', title: "Fecha Siniestro" },
                { name: 'Fecha Reporte', data: 'svfhreporte', title: "Fecha Reporte" },
                { name: 'Fecha Contacto', data: 'svfhcontacto', title: "Fecha Contacto" },
                { name: 'Fecha Termino', data: 'svfhtermino', title: "Fecha Termino" },
                { name: 'Localidad y Estado', data: 'lonombre', title: "Localidad y Estado" },
                { name: 'Proveedor', data: 'prnombre', title: "Proveedor" },
                { name: 'Supervisoria', data: 'susupervisoria', title: "Supervisoria" },
                { name: 'Gerencia', data: 'genombre', title: "Gerencia" },
            ],
            formatterActions: [
                { click: [this, "BuscarDetalleRep"] },
            ],
            listado: '',
            permisoExpJur: false,
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        async fetchData() {
            const response = this.listado;
            return response;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        async BuscarDetalleRep(params, item, fila) {
            let reporte = {
                nrreporte: item.nrreporte,
                svindice: item.svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", item.nrreporte);
            formData.append("svindice", item.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });

            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` });
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ name: `${"Asistencias"}` });
            }
        },
        reporteForm(datos) {
            if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.nrreporte}-${datos.svindice}</span></button></div>`;
            } else {
                return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
            }
        },
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '28').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 28)//Permiso para ver concluidos
                        this.permisoExpJur = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        await this.reloadTable();
    }
}
</script>

<style>
.reporteindice {
    color: var(--v-anchor-base);
}
</style>

